import { TRemoveClientFromArchiveParams } from 'types/services';
import { m8API } from 'services/production/m8';

export const removeClientFromArchive = async (
  params: TRemoveClientFromArchiveParams
) => {
  const { clientId } = params;

  await m8API.admin.removeUserFromArchive(clientId);
};
